import { render, staticRenderFns } from "./IconSvgComment.vue?vue&type=template&id=1129f193&scoped=true&"
import script from "./IconSvgComment.vue?vue&type=script&lang=js&"
export * from "./IconSvgComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1129f193",
  null
  
)

export default component.exports